import { Activity } from '@phosphor-icons/react';

export default Activity;
